import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerV2.css';

const PORTAL_ID = 'pv2-datepicker-root';

const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

function ensurePortalRoot() {
    if (typeof document === 'undefined') return;
    if (document.getElementById(PORTAL_ID)) return;
    const el = document.createElement('div');
    el.id = PORTAL_ID;
    document.body.appendChild(el);
}

/**
 * Portal V2 date picker — dark glass calendar, isolated from classic Step 2 styles.
 */
export default function DatePickerV2({
    selected,
    onChange,
    minDate,
    disabled = false,
    customInput,
    dateFormat = 'MM/dd/yyyy',
    accent,
    label = 'Target date',
    withPortal = true,
}) {
    useEffect(() => {
        ensurePortalRoot();
    }, []);

    const accentStyle = {
        ['--pv2-dp-accent']: accent || '#15c285',
    };

    return (
        <div className="pv2-dp" style={accentStyle}>
            <DatePicker
                dateFormat={dateFormat}
                selected={selected}
                onChange={onChange}
                minDate={minDate}
                disabled={disabled}
                withPortal={withPortal}
                portalId={withPortal ? PORTAL_ID : undefined}
                customInput={customInput}
                calendarClassName="pv2-datepicker"
                popperClassName="pv2-datepicker-popper"
                calendarContainer={({ className, children }) => (
                    <div className={className} style={accentStyle}>
                        {children}
                    </div>
                )}
                renderCustomHeader={({
                    date,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                }) => (
                    <div className="pv2-datepicker__head">
                        <span className="pv2-datepicker__eyebrow">{label}</span>
                        <div className="pv2-datepicker__nav">
                            <button
                                type="button"
                                className="pv2-datepicker__nav-btn"
                                onClick={decreaseMonth}
                                disabled={prevMonthButtonDisabled}
                                aria-label="Previous month"
                            >
                                ‹
                            </button>
                            <strong className="pv2-datepicker__month">
                                {date
                                    ? `${MONTHS[new Date(date).getMonth()]} ${new Date(date).getFullYear()}`
                                    : 'Select a date'}
                            </strong>
                            <button
                                type="button"
                                className="pv2-datepicker__nav-btn"
                                onClick={increaseMonth}
                                disabled={nextMonthButtonDisabled}
                                aria-label="Next month"
                            >
                                ›
                            </button>
                        </div>
                    </div>
                )}
            />
        </div>
    );
}
